import { Route, Routes } from "react-router-dom";
import { Layout } from "./components/Layout.tsx";
import { AskPage } from "./features/ask/AskPage.tsx";
import { SourcesPage } from "./features/sources/SourcesPage.tsx";
import { AboutPage } from "./features/about/AboutPage.tsx";

export default function App() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<AskPage />} />
        <Route path="/sources" element={<SourcesPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="*" element={<AskPage />} />
      </Routes>
    </Layout>
  );
}
